import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCircleMinus, faPowerOff } from '@fortawesome/free-solid-svg-icons';

const COLOR_PASS = '#2BB842';
const COLOR_FAIL = '#FF5555';
const COLOR_OFF = '#BBBBBB';

type MonitorStatusIconProps = {
    status: string;
};

const MonitorStatusIcon = ({ status }: MonitorStatusIconProps): JSX.Element => {
    switch (status) {
        case 'PASS':
            return (
                <FontAwesomeIcon
                    icon={faCheck}
                    color={COLOR_PASS}
                    style={{ strokeWidth: 30, stroke: COLOR_PASS }}
                />
            );
        case 'FAIL':
            return (
                <FontAwesomeIcon
                    icon={faCircleMinus}
                    color={COLOR_FAIL}
                />
            );
        case 'OFF':
        default:
            return (
                <FontAwesomeIcon
                    icon={faPowerOff}
                    color={COLOR_OFF}
                />
            );
    }
};

export default MonitorStatusIcon;
